import { Component, DestroyRef, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormsModule } from "@angular/forms";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { TranslationService } from "../../../services/translation-service";

@Component({
  selector: "app-language-selector",
  standalone: true,
  templateUrl: "./language-selector.component.html",
  styleUrls: ["./language-selector.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslatePipe,
    FormsModule
  ],
})
export class LanguageSelectorComponent implements OnInit {
  /**
   * Visual theme: 'dark' for light text on dark background (landing header),
   * 'light' for dark text on light background (global header top bar).
   */
  @Input() theme: "dark" | "light" = "dark";

  currentLanguage!: string;

  readonly languages = [
    { value: "et", label: "EST" },
    { value: "en", label: "ENG" },
    { value: "ru", label: "RUS" },
  ] as const;

  constructor(
    private translate: TranslateService,
    private translationService: TranslationService,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.currentLanguage = this.translate.currentLang() || "et";
    this.translate.onLangChange
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((event) => {
        this.currentLanguage = event.lang;
      });
  }

  useLanguage(lang: string): void {
    this.translate.use(lang);
    this.currentLanguage = lang;
    this.translationService.setLanguage(lang);
  }
}
